import type { CreateRoomResponse } from "@quizshow/protocol";

export interface StoredRoomSession {
  roomId: string;
  token: string;
  role: "host" | "cohost" | "participant" | "stream";
  roomCode?: string;
  playerId?: string;
  streamUrl?: string;
  cohostUrl?: string;
}

function key(roomId: string, role: StoredRoomSession["role"]): string {
  return `quizshow-session:${roomId}:${role}`;
}

export function storeSession(session: StoredRoomSession): void {
  sessionStorage.setItem(key(session.roomId, session.role), JSON.stringify(session));
}

export function loadSession(roomId: string, role: StoredRoomSession["role"]): StoredRoomSession | undefined {
  const raw = sessionStorage.getItem(key(roomId, role));
  return raw ? (JSON.parse(raw) as StoredRoomSession) : undefined;
}

export function storeCreatedRoom(response: CreateRoomResponse): StoredRoomSession {
  const session: StoredRoomSession = {
    roomId: response.roomId,
    token: response.hostToken,
    role: "host",
    roomCode: response.roomCode,
    streamUrl: response.streamUrl,
    cohostUrl: response.cohostUrl,
  };
  storeSession(session);
  return session;
}

